// src/utils/checkTokenValidity.js
export const checkTokenValidity = async () => {
    const token = localStorage.getItem('authToken');
    if (!token) return;

    try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/validate-token`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });

        if (!response.ok) {
            throw new Error('Invalid token');
        }
    } catch (error) {
        console.log(error);
        localStorage.removeItem('authToken');
        localStorage.removeItem('authUser');
        window.location.reload();
    }
};
